import { Box, Typography } from '@mui/material'

const SingleSectionContainer = ({ sectionTitle, children }) => (
  <Box sx={styles.bodyContainer}>
    <Typography sx={{ fontWeight: 'typography.fontWeightBold', fontSize: { xs: '13px', sm: '18px' } }}>
      {sectionTitle}
    </Typography>
    {children}
  </Box>
)

const styles = {
  bodyContainer: {
    padding: '20px',
    margin: { xs: '0 0 20px 0px', sm: '0 0 40px 20px' },
    backgroundColor: 'white',
    borderRadius: '15px',
    border: 'solid 1px #e2e8ee',
    '.MuiTypography-root': {
      marginBottom: '15px',
    },
  },
}
export default SingleSectionContainer
